// extracted by mini-css-extract-plugin
module.exports = {"container":"commentContainer_container__2xuwU","spacing":"commentContainer_spacing__r6qTt","error":"commentContainer_error__1o2vf"};